import fetch from 'utils/fetch'
export function getUserListByParam (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/user/getUserListByParam`,
    method: 'post',
    data
  })
}
export function modifyUserRole (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/user/modifyUserRole`,
    method: 'post',
    data
  })
}
// 获取无LAB的人
export function getUserListByLabIdIsNull (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/user/getUserListByLabIdIsNull`,
    method: 'post',
    data
  })
}
// 删除某人从当前lab
export function removeUserAndRoleFromLab (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/user/removeUserAndRoleFromLab`,
    method: 'post',
    data
  })
}
export function modifyUserPassWordByUserId (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/user/modifyUserPassWordByUserId`,
    method: 'post',
    data
  })
}
/*export function modifyUserPassWordByUserId (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/user/modifyUserPassWordByUserId`,
    method: 'post',
    data
  })
}*/
export function getUserInfo () {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/user/getUserInfo`,
    method: 'post'
  })
}
export function modifyUserInfo (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/user/modifyUserInfo`,
    method: 'post',
    data
  })
}
export function modifyUserEmail (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/user/modifyUserEmail`,
    method: 'post',
    data
  })
}
export function getRoleByUser () {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/role/getRoleByUser`,
    method: 'post'
  })
}
// 获取可用users
// @params nickName: String , visibilityLevel: ''
export function getUserInfoByName (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/user/getUserInfoByName`,
    method: 'post',
    data
  })
}
// 查看用户邀请内容
export function getUmsLogUserInvite (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/log/getUmsLogUserInvite`,
    method: 'post',
    data
  })
}
export function getUmsLogUserInviteCount (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/log/getUmsLogUserInviteCount`,
    method: 'post',
    data
  })
}
export function updateUmsLogUserInvite (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/log/updateUmsLogUserInvite`,
    method: 'post',
    data
  })
}
// 邀请用户进入项目
export function createUserToProjects (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/project/createUserToProjects`,
    method: 'post',
    data
  })
}
// 获取用户头像
export function Avatar () {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/user/getAvatar`,
    method: 'post'
  })
}
// 修改meta 用户名
export function modifyUserNameInMeta (data) {
  return fetch({
    url: `/project/experiment/modifyUserNameInMeta`,
    method: 'post',
    data
  })
}
// 用户点赞
export function saveUserLiked (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/liked/saveUserLiked`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/users.js